import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, Lingue } from '../../models/-index';

@Injectable()
export class LingueService extends CrudGenericsService<Lingue, string> {
  // private base: string;
  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Lingue`);
    //  this.base = `${env.apiUrl}/api/Lingue/`;
  }
}
